module.exports = __webpack_public_path__ + "img/ring_y_l_null_null@2x.27716d67.png";